import React, { useState, useEffect } from "react";
import { useMemo } from "react";
import "./Title.css";

const Title = () => {
  const words = useMemo(
    () => ["Niche", "Communities", "Passions", "Profits", "New Skills"],
    []
  );
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [displayedWord, setDisplayedWord] = useState(words[0].split(""));

  useEffect(() => {
    const interval = setInterval(() => {
      setDisplayedWord([]);
      setTimeout(() => {
        setCurrentWordIndex((prevIndex) => (prevIndex + 1) % words.length);
        setDisplayedWord(
          words[(currentWordIndex + 1) % words.length].split("")
        );
      }, 500); // Duration of the exit animation
    }, 3000); // Change words every 3 seconds
    return () => clearInterval(interval);
  }, [currentWordIndex, words]);

  return (
    <div className="title-wrapper">
      <div className="title-heading">
        <h1>The platform for Hobbyists</h1>
        <h1>
          Find your{" "}
          <span className="changing-word">
            {displayedWord.map((letter, index) => (
              <span key={index} className="letter">
                {letter}
              </span>
            ))}
          </span>
        </h1>
        <p className="subtitle">
          "The greatest job in the world is the hobby that pays"
        </p>
        <a
          href="https://hobbestie.app/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button className="button i-button">Get Started</button>
        </a>
      </div>
      <div className="blur t-blur1"></div>
      <div className="blur t-blur2"></div>
    </div>
  );
};

export default Title;
